import axios from 'axios';
import {ENV} from '../Environment';


const API_URL2 = 'https://dideco-respaldo.herokuapp.com/api/post-ecologia/public/';

const URLPA ='https://dideco-respaldo.herokuapp.com/api/post-alerta/public/';
const URLPE ='https://dideco-respaldo.herokuapp.com/api/get-cartillas/public/';

const API ='https://smn.tepic.gob.mx/cartillas/cartillasapi/index.php?action=';

/*

const API_URL2 = 'https://dideco-respaldo.herokuapp.com/api/post-ecologia/public/';

const URLPA ='https://dideco-respaldo.herokuapp.com/api/post-alerta/public/';
const URLPE ='https://dideco-respaldo.herokuapp.com/api/get-ecologia/public/';
*/

//const API_URL2 = 'https://dideco-respaldo.herokuapp.com/api/NAD/apisgd/public/';


const GetLogin2 = async (data)=>{
    return await axios.post(API+"loginCartillas"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const PostFile = async (archivo)=>{
    const data = new FormData()
    data.append('fileStg', archivo)
    return await axios.post("https://dideco-apis.herokuapp.com/postfile"
        , data).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const GetEmisor = async ()=>{
    return await axios.get(ENV.REST.URL_MAINARC+"emisor"
        ).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const GetGiro= async ()=>{
    return await axios.get(ENV.REST.URL_MAINARC+"giros"
        ).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};
const GetRequisitos = async ()=>{
    return await axios.get(ENV.REST.URL_MAINRESP+"requisitos"
        ).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       ///* alert(err.toString());*/
        return null;
    });
};


const GetUltimoID = async ()=>{
    return await axios.get(ENV.REST.URL_MAINARC+"ultimoid"
        ).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const oficiosRegistrados = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"oficiosRegistrados"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const OficiosLicencia = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"oficiosLicencias"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const PutOficios = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"complementarOficio"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const ConLicencia = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"conLicencia"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const conCancelado = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"conCancelado"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const conDesCancelado = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"conDesCancelado"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const conDesCanceladoSguimiento = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"conDesCanceladoSguimiento"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};


const ConRefrendo = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"conRefrendo"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};


const oficiosEnProceso = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"oficiosEnProceso"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const oficiosEPR = async (data)=>{
 //   return await axios.post(ENV.REST.URL_MAINARCEP+"oficiosEPR"
    return await axios.post("https://dideco-respaldo.herokuapp.com/api/get-licencias/public/oficiosEPR"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};


const oficiosTodos = async (data)=>{
    //   return await axios.post(ENV.REST.URL_MAINARCEP+"oficiosEPR"
       return await axios.post("https://dideco-respaldo.herokuapp.com/api/get-licencias/public/oficiosTodos"
           ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
           return (response.status === 200) ? response.data : alert(response.data);
       }).catch(err =>{
          /* alert(err.toString());*/
           return null;
       });
   };

const oficiosTurnadosAlArea = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"oficiosTurnadosAlArea"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const respuestaPositivo = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"positivo"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const respuestaCancelado = async (data)=>{
    return await axios.post("https://dideco-respaldo.herokuapp.com/api/get-licencias/public/cancelado"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const respuestaNegativo = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"negativo"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const respuestaSuspendido = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"suspendido"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const registrarOficio = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"registrarOficio"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const registrarDocumento = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"registrarDocumento"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const turnarOficio = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"turnarOficio"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const reporte = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINRESP+"reporte"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const reporteArea = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINRESP+"reporteArea"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const reporteAreaE = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINRESP+"reporteAreaE"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const reporteAreasEstatus = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINRESP+"reporteAreasEstatus"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const reporteLic = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINRESP+"reporteLic"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};


const imprimir = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"imprimir"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const dictamenOficio = async (data)=>{
    return await axios.post(ENV.REST.URL_MAINARC+"dictamenOficio"
        ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};

const GetDetalleOficio = async (data) =>{
    return await axios.post(ENV.REST.URL_MAINARC+"oficioID"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetDocumentosID= async (data) =>{
    return await axios.post(ENV.REST.URL_MAINRESP+"documentosID"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
    //alert(err.toString());
    return null;
});
 }

 const GetSeguimientoOficio = async (data) =>{
    return await axios.post(ENV.REST.URL_MAINARC+"oficioSeguimiento"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetPGIR = async (data) =>{
    return await axios.post(ENV.REST.URL_MAINARC+"getpgir"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const POSTPGIR = async (data) =>{
    return await axios.post(ENV.REST.URL_MAINARC+"pgir"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const POSTRETURNAR = async (data) =>{
    return await axios.post(ENV.REST.URL_MAINARC+"returnarOficio"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const POSTRETURNARRF = async (data) =>{
    return await axios.post(ENV.REST.URL_MAINARC+"returnarOficioRF"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const DelArchivo = async (data) =>{
    return await axios.post(ENV.REST.URL_MAINARC+"deleteDocumento"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

const GetUserPermissions = async (idUser, tipoPagina) => {
    return await axios.get(ENV.REST.URL_MAIN
        + ENV.REST.MODULES.SECURITY.NAME_ROUTE
        + ENV.REST.MODULES.SECURITY.ACTIONS.GET_SECURITY_USER_PERMISSIONS
            .replace(":idUser", idUser)
            .replace(":tipoPagina", tipoPagina))
            .then(response=>{
                return (response.status === 200) ? response.data : alert(response.data);
            }).catch(err =>{
               /* alert(err.toString());*/
                return null;
            });;
};

const PutSecurityProfilePhoto = async (idPersona, rutaFoto) => {
    
    await axios.put(ENV.REST.URL_MAIN
        + ENV.REST.MODULES.SECURITY.NAME_ROUTE
        + ENV.REST.MODULES.SECURITY.ACTIONS.PUT_SECURITY_PROFILE_PHOTO
            .replace(":IdPersona", idPersona), rutaFoto)
            .then(response=>{
                return (response.status === 200) ? response.data : null;
            })
            .catch(err =>{
               /* alert(err.toString());*/
                return null;
            });
};

const PutSecurityProfileImage = async (image) => {
    const formData = new FormData();
    formData.append('uploadedfile', image.files[0]);
    return await axios.post('https://thecaveoflittlereik.000webhostapp.com/AppEvaRest/subirImagenes.php', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }).then(response => image.files[0].name)
    .catch(err => image.files[0].name);
};


const PostInspeccion = async (data) =>{
    return await axios.post(API_URL2+"reginspeccionDIDECO"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 };



 const UPDGiroNegocio = async (data) =>{
    return await axios.post(URLPA+"actGiroNegocio"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }


 const PostRegulacion = async (data) =>{
    return await axios.post(URLPE+"regregulacion2"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const PostInspeccionPC = async (data) =>{
    return await axios.post(URLPE+"regdidecoPC"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const UPDACR = async (data) =>{
    return await axios.put(URLPE+"actacR"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const UPDCR = async (data) =>{
    return await axios.put(URLPE+"actcR"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }


 const UPDOCR = async (data) =>{
    return await axios.put(URLPE+"actocR"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const UPDOVR = async (data) =>{
    return await axios.put(URLPE+"actovR"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }


 const GetCartillas = async (data) =>{
    return await axios.get(API+"registrosCartillas").then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const POSTCartilla= async (data) =>{
    return await axios.post(API+"regCartilla"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const UPDCartilla= async (data) =>{
    return await axios.post(API+"updCartilla"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }




 const POSTPreregistro= async (data) =>{
    return await axios.post(API+"regpreregistro"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const UPDPreregistro= async (data) =>{
    return await axios.post(API+"actpreregistro"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 
 const POSTNoregistro= async (data) =>{
    return await axios.post(API+"regnoregistro"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const UPDNoregistro= async (data) =>{
    return await axios.post(API+"actnoregistro"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const POSTCC= async (data) =>{
    return await axios.post(API+"cita_cartilla"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const UPDCC= async (data) =>{
    return await axios.post(API+"actcita"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const UPDCCE= async (data) =>{
    return await axios.post(API+"actcitaE"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }


 const POSTCT= async (data) =>{
    return await axios.post(API+"regCartillaT"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }


 const UPDCT= async (data) =>{
    return await axios.post(API+"actcartillat"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }


 const UPDCTCM= async (data) =>{
    return await axios.post(API+"actcartillacm"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const UPDCTE= async (data) =>{
    return await axios.post(API+"actcartillatE"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const UPDCRQ= async (data) =>{
    return await axios.post(API+"deletecr"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const POSTCRQ= async (data) =>{
    return await axios.post(API+"regCartillaR"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const UPDCRQR= async (data) =>{
    return await axios.post(API+"actCartillaR"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetCatRequisitosCartillas = async (data) =>{
    return await axios.get(API+"cat_requisitos_car").then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetPreregistros = async (data) =>{
    return await axios.get(API+"preregistros").then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetNoregistros = async (data) =>{
    return await axios.get(API+"noregistros").then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetPreregistrosN = async (data) =>{
    return await axios.get(API+"preregistrosN").then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetPreregistrosNumero = async (data) =>{
    return await axios.get(API+"preregistrosNumero").then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetPreregistrosCN = async (data) =>{
    return await axios.post("https://dideco-respaldo.herokuapp.com/preregistrosCN",data).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetPreregistrosCNB = async (data) =>{
    return await axios.post(API+"preregistrosCNB",data, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetCitasCartillas = async (data) =>{
    return await axios.get(API+"citas_cartillas").then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetEstatusCartillas = async (data) =>{
    return await axios.get(API+"cat_estatus_car").then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

const GetCitasDisponibles= async (data) =>{
    return await axios.post(API+"registrosCitas"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }


 const GetCitasFecha= async (data) =>{
    return await axios.post(API+"citas_estatus_fecha"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetCitasEstatus= async (data) =>{
    return await axios.post(API+"citas_estatus"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetCTEstatus= async (data) =>{
    return await axios.post(API+"ct_estatus"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }


 const GetCTEstatusN= async (data) =>{
    return await axios.post("https://dideco-respaldo.herokuapp.com/ct_estatusN"
    ,data).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetCTEstatusNB= async (data) =>{
    return await axios.post(API+"ct_estatusNB"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetCTSID= async (data) =>{
    return await axios.post(API+"cts_id"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetCTID= async (data) =>{
    return await axios.post(API+"ct_id"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetPreregistroID= async (data) =>{
    return await axios.post(API+"preregistro_id"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetCTRep= async (data) =>{
    return await axios.post(API+"ct_rep"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetCTRepCM= async (data) =>{
    return await axios.post(API+"ct_repcm"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

 const GetCTRepNR= async (data) =>{
    return await axios.post(API+"ct_repnr"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }
 const CorreoCartillas = async (data)=>{
    return await axios.post("https://smn.tepic.gob.mx/correo/correo.php",data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
        return (response.status === 200) ? response.data : alert(response.data);
    }).catch(err =>{
       /* alert(err.toString());*/
        return null;
    });
};


 const GetCRID= async (data) =>{
    return await axios.post(API+"cr_id"
    ,data , {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(response=>{
    return (response.status === 200) ? response.data : alert(response.data);
}).catch(err =>{
   /* alert(err.toString());*/
    return null;
});
 }

export {GetDocumentosID,POSTPreregistro,UPDPreregistro,GetPreregistrosN,GetPreregistrosCNB,GetPreregistrosNumero,UPDCTCM,GetCTRepCM,GetCTRepNR,GetNoregistros,POSTNoregistro,UPDNoregistro,GetCTEstatusN,GetCTEstatusNB,GetPreregistrosCN,POSTCC,CorreoCartillas,GetCTRep,UPDCC,UPDCCE,POSTCT,UPDCT,UPDCTE,UPDCRQ,POSTCRQ,UPDCRQR,GetCatRequisitosCartillas,GetPreregistros,GetCitasCartillas,GetEstatusCartillas,GetCitasDisponibles,GetCitasFecha,GetCitasEstatus,GetCTEstatus,GetCTSID,GetCTID,GetPreregistroID,GetCRID,GetCartillas,POSTCartilla,UPDCartilla,reporteLic,respuestaCancelado,oficiosTodos,conCancelado,conDesCancelado,conDesCanceladoSguimiento,reporteArea,reporteAreaE,reporteAreasEstatus,ConRefrendo,POSTRETURNARRF,PostInspeccionPC,PostRegulacion,UPDACR,UPDCR,UPDOCR,UPDOVR,oficiosEPR,UPDGiroNegocio, PostInspeccion,DelArchivo,imprimir,GetPGIR,POSTPGIR,reporte,ConLicencia,OficiosLicencia,POSTRETURNAR,PutOficios,dictamenOficio,respuestaNegativo,respuestaSuspendido,GetGiro,GetUltimoID,respuestaPositivo,GetRequisitos,PostFile, GetLogin2, GetEmisor,oficiosEnProceso,oficiosRegistrados,registrarDocumento ,GetDetalleOficio,GetSeguimientoOficio,turnarOficio,oficiosTurnadosAlArea,registrarOficio,GetUserPermissions, PutSecurityProfileImage, PutSecurityProfilePhoto};